import { writable } from 'svelte/store';
export let textFilter = writable("");
export let typeFilter = writable("filterAll");
export let sizeFilter = writable("filterAll");
export let lightFilter = writable("filterAll");
export let colorFilter = writable("filterAll");
export let seasonFilter = writable("filterAll");

export let promoteExtraPlantPackage = writable(false);
